import axios from "axios";
import jwtDecode from "jwt-decode";
import { logout } from "./authService";
import config from "../config/envConfig";

export const host = config.backendEndpoint;
export const emailHost = config.emailEndpoint;

var auth_token = "";

function setTokenInHeader(token) {
  auth_token = token;
}

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
  }
  return Promise.reject(error);
});

axios.interceptors.request.use(function (config) {
  if (!config.headers["Authorization"]) {
    if (auth_token) {
      if (!(auth_token && jwtDecode(auth_token)["exp"] * 1000 >= Date.now())) {
        logout();
        return;
      }
      config.headers["Authorization"] = `Bearer ${auth_token}`;
      return config;
    }
    return config;
  }
  return config;
});

const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setTokenInHeader,
};

export default http;
